import React, { useState } from 'react'
import { Button, Text, Box, Divider, Link } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { AuthLayout, BaseHeading } from '../../components'
import { Input } from '../../components/form'
import { ROUTES } from '../../contants'
import useResetStore from '../../state/Reset.store'
import { screens } from './types'

const Reset = () => {
  const [sendOTP, loading, setScreen] = useResetStore((state) => [
    state.sendOTP,
    state.loading,
    state.setScreen
  ])

  const {
    register,
    handleSubmit,
    formState: { errors, touchedFields, isValid },
    watch
  } = useForm({
    mode: 'onChange'
  })

  const onSubmit = async (data: any) => {
    try {
      const datas = await sendOTP(data.email)
      if (datas) {
        setScreen(screens.ENTER_OTP)
      }
    } catch (error) {
      console.log('error')
    }
  }

  return (
    <AuthLayout previous>
      <Box as="form" onSubmit={handleSubmit(onSubmit)}>
        <BaseHeading title="Reset PIN" />
        <Text fontSize="1.2rem" mb="3.2rem">
          Please enter the email address associated with your Kappa account.
        </Text>

        <Input
          isValid={watch('email') && touchedFields.email && !errors.email && true}
          isError={touchedFields.email && errors.email && errors.email.message}
          type="email"
          label="Email"
          id="email"
          value={watch('email')}
          formHook={register('email', {
            required: 'Email is required',
            maxLength: { value: 100, message: 'Maximum of 100 characters' },
            pattern: {
              value: /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              message: 'Email is invalid'
            }
          })}
        />

        <Button
          isDisabled={!isValid}
          mb="2.4rem"
          type="submit"
          isFullWidth
          isLoading={loading}
          variant="blue">
          Reset PIN
        </Button>
        <Link
          fontWeight="500"
          as={RouterLink}
          d="block"
          mb="8.7rem"
          textAlign="center"
          to={ROUTES.login}
          _hover={{ border: 'none', outline: 'none' }}
          _active={{ border: 'none', outline: 'none' }}
          _focus={{ border: 'none', outline: 'none' }}>
          Remember PIN?{' '}
          <Text fontWeight="500" as="span" color="brand.blue">
            Login
          </Text>
        </Link>

        <Divider mb="2rem" />
        <Text textAlign="center">
          Get Started{' '}
          <Link
            fontWeight="500"
            color="brand.blue"
            as={RouterLink}
            to={ROUTES.insurance}
            _hover={{ border: 'none', outline: 'none' }}
            _active={{ border: 'none', outline: 'none' }}
            _focus={{ border: 'none', outline: 'none' }}>
            Buy Insurance
          </Link>
        </Text>
      </Box>
    </AuthLayout>
  )
}

export { Reset }
